var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarXs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7164_15027)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.99992 4.0068C1.90787 4.0068 1.83325 4.08141 1.83325 4.17346V14.8401C1.83325 14.9322 1.90787 15.0068 1.99992 15.0068H13.9999C14.092 15.0068 14.1666 14.9322 14.1666 14.8401V4.17346C14.1666 4.08141 14.092 4.0068 13.9999 4.0068H1.99992ZM0.833252 4.17346C0.833252 3.52913 1.35559 3.0068 1.99992 3.0068H13.9999C14.6442 3.0068 15.1666 3.52913 15.1666 4.17346V14.8401C15.1666 15.4845 14.6442 16.0068 13.9999 16.0068H1.99992C1.35559 16.0068 0.833252 15.4845 0.833252 14.8401V4.17346Z",
    fill: "#2D2943"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833252 7.50679C0.833252 7.23065 1.05711 7.00679 1.33325 7.00679H14.6666C14.9427 7.00679 15.1666 7.23065 15.1666 7.50679C15.1666 7.78294 14.9427 8.00679 14.6666 8.00679H1.33325C1.05711 8.00679 0.833252 7.78294 0.833252 7.50679Z",
    fill: "#2D2943"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833252 11.5068C0.833252 11.2307 1.05711 11.0068 1.33325 11.0068H14.6666C14.9427 11.0068 15.1666 11.2307 15.1666 11.5068C15.1666 11.7829 14.9427 12.0068 14.6666 12.0068H1.33325C1.05711 12.0068 0.833252 11.7829 0.833252 11.5068Z",
    fill: "#2D2943"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66658 1.67346C5.94273 1.67346 6.16658 1.89732 6.16658 2.17346V4.84013C6.16658 5.11627 5.94273 5.34013 5.66658 5.34013C5.39044 5.34013 5.16658 5.11627 5.16658 4.84013V2.17346C5.16658 1.89732 5.39044 1.67346 5.66658 1.67346Z",
    fill: "#2D2943"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3333 1.67346C10.6094 1.67346 10.8333 1.89732 10.8333 2.17346V4.84013C10.8333 5.11627 10.6094 5.34013 10.3333 5.34013C10.0571 5.34013 9.83325 5.11627 9.83325 4.84013V2.17346C9.83325 1.89732 10.0571 1.67346 10.3333 1.67346Z",
    fill: "#2D2943"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66658 7.00679C5.94273 7.00679 6.16658 7.23065 6.16658 7.50679V15.5068C6.16658 15.7829 5.94273 16.0068 5.66658 16.0068C5.39044 16.0068 5.16658 15.7829 5.16658 15.5068V7.50679C5.16658 7.23065 5.39044 7.00679 5.66658 7.00679Z",
    fill: "#2D2943"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3333 7.00679C10.6094 7.00679 10.8333 7.23065 10.8333 7.50679V15.5068C10.8333 15.7829 10.6094 16.0068 10.3333 16.0068C10.0571 16.0068 9.83325 15.7829 9.83325 15.5068V7.50679C9.83325 7.23065 10.0571 7.00679 10.3333 7.00679Z",
    fill: "#2D2943"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6666 4.67346C14.9427 4.67346 15.1666 4.89732 15.1666 5.17346V13.8401C15.1666 14.1163 14.9427 14.3401 14.6666 14.3401C14.3904 14.3401 14.1666 14.1163 14.1666 13.8401V5.17346C14.1666 4.89732 14.3904 4.67346 14.6666 4.67346Z",
    fill: "#2D2943"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33325 4.67346C1.60939 4.67346 1.83325 4.89732 1.83325 5.17346V13.8401C1.83325 14.1163 1.60939 14.3401 1.33325 14.3401C1.05711 14.3401 0.833252 14.1163 0.833252 13.8401V5.17346C0.833252 4.89732 1.05711 4.67346 1.33325 4.67346Z",
    fill: "#2D2943"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16658 15.5068C4.16658 15.2307 4.39044 15.0068 4.66658 15.0068H11.3333C11.6094 15.0068 11.8333 15.2307 11.8333 15.5068C11.8333 15.7829 11.6094 16.0068 11.3333 16.0068H4.66658C4.39044 16.0068 4.16658 15.7829 4.16658 15.5068Z",
    fill: "#2D2943"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7164_15027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.840149)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarXs);
export default __webpack_public_path__ + "static/media/calendar-xs.98eef24c.svg";
export { ForwardRef as ReactComponent };